module.exports = __webpack_public_path__ + "static/img/pic_07@2x.6e6ce887.png";